var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hamburger",staticStyle:{"padding":"0 10px"},on:{"click":_vm.toggleClick}},[_c('i',{class:_vm.isActive ? 'el-icon-s-fold' : 'el-icon-s-unfold'})])
}
var staticRenderFns = []

export { render, staticRenderFns }